import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'

export default () => {
    const map = useMapContext()
    const {mapTypeCode, prjId, prjPatternId, sVer} = map.data

    if ('SA_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = e => {
        const target = e.altKey ? '_self' : '_blank'
        openWindow('/FormilyPreview', {prjId, prjPatternId, sVer}, target)
    }

    return {
        label: '界面看板',
        onClick,
    }
}
